import * as yup from 'yup';
import CNPJValidador from './CNPJValidator';


export const FormValidationCreateClient = yup.object().shape({
  email: yup
    .string()
    .required('Email é obrigatório')
    .email('Email deve ser válido')
    .max(255, 'Email deve ter no máximo 255 caracteres'),
  cnpj: yup
    .string()
    .required('CNPJ é obrigatório')
    .test('cnpj-valid', 'CNPJ inválido', function (value) {
      return CNPJValidador.validate(value);
    })
});
